import { render, staticRenderFns } from "./ForcPerformanceComparison.vue?vue&type=template&id=e24453ae&scoped=true&"
import script from "./ForcPerformanceComparison.vue?vue&type=script&lang=js&"
export * from "./ForcPerformanceComparison.vue?vue&type=script&lang=js&"
import style0 from "./ForcPerformanceComparison.vue?vue&type=style&index=0&id=e24453ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24453ae",
  null
  
)

export default component.exports